import { Button, Tooltip } from '@cmg/design-system';
import React from 'react';

import { useDownloadCertificate } from './hooks/useDownloadCertificate';

export type Props = {
  cmgEntityKey: string;
};

const CertificateDownloadButton: React.FC<Props> = ({ cmgEntityKey }) => {
  const { loading, handleDownloadCertificate } = useDownloadCertificate(cmgEntityKey);

  return (
    <Tooltip title="View certificate" variant="info" placement="top">
      <span>
        <Button
          variant="text"
          disabled={loading}
          onClick={handleDownloadCertificate}
          aria-label="view certificate"
        >
          View
        </Button>
      </span>
    </Tooltip>
  );
};

export default CertificateDownloadButton;
